import React from 'react';
import { Card, Alert } from 'antd';

interface Props {
    initialConfig?: Record<string, any>;
    onChange?: (config: Record<string, any>) => void;
}

export const SectionConfigMeasurementList: React.FC<Props> = () => {
    return (
        <Card size="small" style={{ background: '#f5f5f5' }}>
            <Alert
                message="List of Measurements"
                description="Shows measurements for the current area, pattern, or pattern point. Includes timestamps and all captured value types, with filters, sorting, and CSV/ZIP export."
                type="info"
                showIcon
            />
        </Card>
    );
};

export default SectionConfigMeasurementList;
